import { render } from "./MainSidebar.vue?vue&type=template&id=2a5797fc"
import script from "./MainSidebar.vue?vue&type=script&lang=js"
export * from "./MainSidebar.vue?vue&type=script&lang=js"

import "@/assets/styles/layout/sidebar.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__